// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3G6fb","footer":"ModalUpdate_footer__GNtQv"};